import { render } from "./Index.vue?vue&type=template&id=6cbdb47a&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=6cbdb47a&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=6cbdb47a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbdb47a"]])

export default __exports__